import { pick } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';
import { injectIntl } from 'react-intl';

import { black5, evisortRed } from '../../../assets/shared-styles/general';
import { MODAL_FOLDER_TREE } from '../../../types/modal.types';
import EcModal from '../EcModal/EcModal';
import EcMultipleSelectValue from '../EcMultipleSelectValue/EcMultipleSelectValue';
import CheckmarkIcon from '../Icons/CheckmarkIcon';
import SubArrowIcon from '../Icons/SubArrowIcon';
import styles from './EcFilterFolderField.styles';

const toFolderFilterValues = (folder) => pick(folder, ['id', 'name', 'path']);

class EcFilterFolderField extends Component {
  constructor(props) {
    super(props);

    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleFoldersChange = this.handleFoldersChange.bind(this);
    this.state = { currentModal: null };
  }

  handleShowModal(currentModal) {
    this.setState({ currentModal });
  }

  handleHideModal() {
    this.setState({ currentModal: null });
  }

  handleFoldersChange(locations) {
    const { folders, onChange } = this.props;

    let newFolders = folders ? [...folders] : [];
    newFolders = [...newFolders, ...locations].map(toFolderFilterValues);

    const folder_ids = newFolders.map((f) => f.id);
    onChange({ folders: newFolders, folder_ids, error: false });
  }

  renderMultiSelectFolderTreeModal() {
    const { folders, intl } = this.props;

    const folderIdsSelected = folders ? folders.map((folder) => folder.id) : [];

    return (
      <EcModal
        modalType={MODAL_FOLDER_TREE}
        width="540px"
        title={intl.formatMessage({
          id: 'EcFilterFolderField.chooseFoldersTitle',
          defaultMessage: 'Choose Folders to Search',
          description: 'Modal title for selecting folders to search',
        })}
        folderIdsSelected={folderIdsSelected}
        handleChooseMultipleLocationsClick={this.handleFoldersChange}
        confirmButtonIcon={<CheckmarkIcon size="20" />}
        confirmButtonText={intl.formatMessage({
          id: 'EcFilterFolderField.chooseFoldersButton',
          defaultMessage: 'Choose Folders',
          description: 'Button text to confirm folder selection',
        })}
        hideModal={this.handleHideModal}
        isMultiSelect
      />
    );
  }

  renderMultipleValues() {
    const { classes, folders, onChange, intl } = this.props;

    if (!(folders && folders.length)) {
      return (
        <span className={classes.multipleValuesEmpty}>
          {intl.formatMessage({
            id: 'EcFilterFolderField.noValuesSelected',
            defaultMessage: 'No values selected...',
            description: 'Placeholder text when no folders are selected',
          })}
        </span>
      );
    }

    return folders.map((value, index) => {
      const path = value.path.map((pathFolder) => pathFolder.name).join(' → ');
      return (
        <Fragment key={index}>
          <Tooltip
            id={`folder-tooltip-${value.id}-${index}`}
            tooltip={path}
            placement="bottom"
          >
            <div data-tip data-for={`folder-tooltip-${value.id}-${index}`}>
              <EcMultipleSelectValue
                label={value.name}
                closeHandler={() => {
                  const multipleValues = [...folders];
                  multipleValues.splice(index, 1);

                  const folder_ids = multipleValues.map((f) => f.id);
                  onChange({ folders: multipleValues, folder_ids });
                }}
              />
            </div>
          </Tooltip>
        </Fragment>
      );
    });
  }

  render() {
    const { classes, onRemoveClick, onFilterNameClick, error, intl } =
      this.props;
    const { currentModal } = this.state;

    return (
      <div className={classes.ecFilterFieldWrapper}>
        <div className={classes.ecFilterField}>
          <IconButton
            onClick={onRemoveClick}
            text={intl.formatMessage({
              id: 'EcFilterFolderField.removeField',
              defaultMessage: 'Remove Field',
              description: 'Button text to remove folder field',
            })}
            icon="x"
          />
          <Button
            onClick={onFilterNameClick}
            text={intl.formatMessage({
              id: 'EcFilterFolderField.folder',
              defaultMessage: 'Folder',
              description: 'Label for folder filter field',
            })}
            icon="chevron-down"
          />
        </div>
        <Layout mt={14} ml={28}>
          <Button
            variant="action"
            icon="plus"
            iconPosition="left"
            text={intl.formatMessage({
              id: 'EcFilterFolderField.addFolder',
              defaultMessage: 'Add a Folder',
              description: 'Button text to add a folder to the filter',
            })}
            onClick={() => this.handleShowModal(MODAL_FOLDER_TREE)}
          />
        </Layout>
        <div className={classes.multipleValuesContainer}>
          <SubArrowIcon color={error ? evisortRed : black5} />
          <div className={classes.multipleValues}>
            {this.renderMultipleValues()}
          </div>
        </div>
        {currentModal === MODAL_FOLDER_TREE &&
          this.renderMultiSelectFolderTreeModal()}
      </div>
    );
  }
}

EcFilterFolderField.propTypes = {
  entity: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onFilterNameClick: PropTypes.func.isRequired,
  folders: PropTypes.array,
  error: PropTypes.bool,
};

export default injectSheet(styles)(injectIntl(EcFilterFolderField));
